import { createSlice } from "@reduxjs/toolkit";
import {   home_investment_withdrawalThunk } from "./thunk";


export const initialState = {
  investmentWithdrawalData: [],
  investmentWithdrawalError: {
    code: null,
    message: '',
    data: null
  },
  investmentWithdrawalLoading: false,
  
  
};

const Home_Investment_Withdrawal = createSlice({
  name: "Home_Investment_Withdrawal",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_investment_withdrawalThunk.pending, (state) => {
      state.investmentWithdrawalLoading = true ;
      state.investmentWithdrawalError = initialState.investmentWithdrawalError; 
  });
    builder.addCase(home_investment_withdrawalThunk.fulfilled, (state, action) => {
        state.investmentWithdrawalData = action.payload.data;
        state.investmentWithdrawalLoading = false ;
    });
    builder.addCase(home_investment_withdrawalThunk.rejected, (state, action) => {
      state.investmentWithdrawalError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.investmentWithdrawalLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_Investment_Withdrawal.actions

export default Home_Investment_Withdrawal.reducer;